import { render, staticRenderFns } from "./TableCellGeneric.vue?vue&type=template&id=0fb6ee08&scoped=true"
import script from "./TableCellGeneric.vue?vue&type=script&lang=ts"
export * from "./TableCellGeneric.vue?vue&type=script&lang=ts"
import style0 from "./TableCellGeneric.vue?vue&type=style&index=0&id=0fb6ee08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb6ee08",
  null
  
)

export default component.exports